
(function () {
  'use strict';
  var LINKS = {bundle:'bundle', treats:'treats', meal:'meal'};
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  var config = JSON.parse(document.getElementById('hp-catalog').textContent);
  var catalog = config.products, root = config.root, busy = false;
  var status = document.getElementById('hp-commerce-status');
  function money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:config.currency || 'USD'}).format(cents / 100); }
  function keysFor(offer) { return offer === 'bundle' ? ['meal','treats'] : [offer]; }
  function canBuy(offer) { return keysFor(offer).every(function (key) { return catalog[key] && catalog[key].available && catalog[key].price > 0; }); }
  function priceFor(offer) { return keysFor(offer).reduce(function (sum,key) { return sum + catalog[key].price; },0); }
  function renderCommerce() {
    $$('[data-hp-price]').forEach(function(el) { el.textContent = money(priceFor(el.dataset.hpPrice)); });
    $$('[data-hp-offer]').forEach(function(el) {
      if (!el.dataset.hpLabel) {
        el.dataset.hpShowPrice = String(el.textContent.includes(' · '));
        el.dataset.hpLabel = el.textContent.split(' · ')[0];
      }
      var offer = el.dataset.hpOffer, available = canBuy(offer);
      el.setAttribute('aria-disabled', String(busy || !available));
      el.setAttribute('aria-busy', String(busy));
      el.textContent = busy ? 'Adding…' : available ? el.dataset.hpLabel + (el.dataset.hpShowPrice === 'true' ? ' · ' + money(priceFor(offer)) : '') : offer === 'bundle' ? 'Bundle unavailable' : 'Sold out';
      el.href = root + 'products/' + catalog[offer === 'treats' ? 'treats' : 'meal'].handle;
    });
    if (range) renderCalc();
  }
  async function refreshCatalog() {
    var responses = await Promise.all(['treats','meal'].map(async function(key) {
      var response = await fetch(root + 'products/' + catalog[key].handle + '.js', {credentials:'same-origin',cache:'no-store'});
      if (!response.ok) throw new Error('Could not check live availability. Please try again.');
      var product = await response.json();
      var variant = product.variants.find(function(v) { return String(v.id) === String(catalog[key].id); });
      if (!variant || !Number.isFinite(variant.price)) throw new Error('This bag is not currently available.');
      return {key:key, variant:variant};
    }));
    responses.forEach(function(r) { catalog[r.key].price = r.variant.price; catalog[r.key].available = r.variant.available; });
    renderCommerce();
  }
  function continuation(message) {
    status.replaceChildren(document.createTextNode(message + ' '));
    [['Review bag', root+'cart'],['Checkout',root+'checkout']].forEach(function(item) {
      var a = document.createElement('a'); a.href=item[1]; a.textContent=item[0]; a.className='hp-cart-link';
      status.append(a,document.createTextNode(' '));
    });
  }
  document.addEventListener('click',async function(event) {
    var cta = event.target.closest('[data-hp-offer]');
    if (!cta) return;
    event.preventDefault();
    if (busy) return;
    var offer = cta.dataset.hpOffer;
    busy = true; renderCommerce(); status.textContent = 'Checking live availability…';
    var adding = false;
    try {
      var previousPrice = priceFor(offer);
      await refreshCatalog();
      if (!canBuy(offer)) throw new Error(offer === 'bundle' ? 'Both bags must be in stock to add the bundle. Choose an available bag instead.' : 'This bag is sold out.');
      if (priceFor(offer) !== previousPrice) throw new Error('The live price has changed. Review the updated price and click again to add.');
      adding = true;
      var response = await fetch(root+'cart/add.js', {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:keysFor(offer).map(function(key) { return {id:catalog[key].id,quantity:1}; })})});
      var result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Could not add your bags.');
      continuation('Added to your bag. Your existing items are still there.');
    } catch (error) {
      if (adding) {
        continuation((error.message || 'Could not confirm the add.') + ' Review your bag before retrying; some items may have been added.');
        try { await refreshCatalog(); } catch (_) {}
      } else { status.textContent = error.message || 'Please try again.'; }
    } finally { busy = false; renderCommerce(); }
  });
  window.addEventListener('pageshow',function(event) { if (event.persisted) refreshCatalog().catch(function() {}); });

  /* ---------- Shake the bag ---------- */
  var shakes = 0;
  var MSGS = [
    'Go on. Give the bag a shake.',
    'One ear just went up.',
    'Both ears. Full head tilt.',
    'Tail is now at helicopter speed.',
    'A nose is pressed firmly against your leg.',
    'ZOOMIES UNLOCKED. You know what you have to do.'
  ];
  var stage = $('#stage'), burst = $('#burst'), pips = $$('#meter .pip');
  $('#shake-btn').addEventListener('click', function () {
    shakes += 1;
    var ph = shakes % 2 ? 'a' : 'b';
    stage.classList.remove('shake-a', 'shake-b'); stage.classList.add('shake-' + ph);
    burst.classList.remove('burst-a', 'burst-b'); burst.classList.add('burst-' + ph);
    var level = Math.min(shakes, 5);
    pips.forEach(function (p, i) { p.classList.toggle('on', i < level); });
    $('#shake-msg').textContent = MSGS[level];
    $('#meter').setAttribute('aria-label', 'Excitement level ' + level + ' of 5');
    if (level >= 5) { $('#shake-unlock').hidden = false; }
  });

  /* ---------- Matchmaker ---------- */
  var RESULTS = {
    snack: { show: 'treats', h: 'Start with the Noms.', p: 'Single-protein beef and liver that snaps into training-size bits. High-value enough to get a “sit” out of a dog who has been ignoring you all afternoon.', href: LINKS.treats, cta: 'Get the Noms' },
    bored: { show: 'meal', h: 'Top the bowl with Beefy-Tato.', p: 'Mix a little into the food they already eat. HeyPup says just 20% in the bowl can deliver meaningful nutritional support, and the sniff-and-walk-away turns into lick-and-look-up.', href: LINKS.meal, cta: 'Get Beefy-Tato' },
    raw: { show: 'meal', h: 'Go full Beefy-Tato.', p: 'Complete and balanced for all life stages. Mix it in and phase out the old food over 7 to 10 days. Serve it dry, no thawing, no freezer.', href: LINKS.meal, cta: 'Get Beefy-Tato' },
    all: { show: 'two', h: 'The Best Friends Bundle.', p: 'Noms for the “sit,” Beefy-Tato for the bowl. Spoiled? No. Correctly loved.', href: LINKS.bundle, cta: 'Get both bags' }
  };
  var picks = 0, result = $('#result');
  $$('.chip').forEach(function (chip) {
    chip.addEventListener('click', function () {
      $$('.chip').forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
      var r = RESULTS[chip.getAttribute('data-deal')];
      $$('[data-show]', result).forEach(function (el) { el.hidden = el.getAttribute('data-show') !== r.show; });
      $('#res-h').textContent = r.h;
      $('#res-p').textContent = r.p;
      var cta = $('#res-cta'); cta.textContent = r.cta; cta.dataset.hpOffer = r.href; cta.dataset.hpLabel = r.cta; renderCommerce();
      picks += 1;
      result.classList.remove('res-a', 'res-b');
      result.classList.add(picks % 2 ? 'res-a' : 'res-b');
    });
  });

  /* ---------- Scoop calculator (numbers from the Beefy-Tato label) ---------- */
  var CUPS_PER_BAG = 850 * 4.045 / 486; // 850 g bag, 4,045 kcal/kg, 486 kcal per cup = ~7.07 cups
  
  var mode = 'topper';
  function frac(x) {
    var whole = Math.floor(x + 1e-9), rest = x - whole, pre = whole > 0 ? String(whole) : '';
    if (Math.abs(rest - 1 / 3) < 0.02) { return pre + '⅓'; }
    if (Math.abs(rest - 2 / 3) < 0.02) { return pre + '⅔'; }
    var e = Math.round(rest * 8);
    if (e === 8) { whole += 1; e = 0; pre = String(whole); }
    if (whole === 0 && e === 0) { e = 1; }
    return pre + ['', '⅛', '¼', '⅜', '½', '⅝', '¾', '⅞'][e];
  }
  function fullCups(w) { // complete-meal guide: 6/12/18/25/50 lb, +½ cup per 10 lb over 50
    var pts = [[6, 0.5], [12, 0.75], [18, 1.25], [25, 1.5], [50, 2.75]];
    if (w <= 6) { return 0.5; }
    if (w > 50) { return 2.75 + 0.05 * (w - 50); }
    for (var i = 1; i < pts.length; i++) {
      if (w <= pts[i][0]) { var a = pts[i - 1], b = pts[i]; return a[1] + (b[1] - a[1]) * (w - a[0]) / (b[0] - a[0]); }
    }
    return 2.75;
  }
  function mixer(w) { // mixer guide brackets
    var br = [[6, 25, 0.125, 0.5, '⅛–½'], [26, 50, 0.5, 0.75, '½–¾'], [51, 70, 0.75, 1, '¾–1'], [71, 100, 1, 4 / 3, '1–1⅓']];
    for (var i = 0; i < br.length; i++) {
      var b = br[i];
      if (w <= b[1]) { var t = Math.max(0, (w - b[0]) / (b[1] - b[0])); return { cups: b[2] + (b[3] - b[2]) * t, range: b[4] }; }
    }
    return { cups: 4 / 3, range: '1–1⅓' };
  }
  function sizeTag(w) {
    return w <= 15 ? 'pocket rocket' : w <= 30 ? 'couch-sized' : w <= 50 ? 'lap dog (allegedly)' : w <= 75 ? 'big floof' : 'basically a pony';
  }
  var range = $('#hp-weight');
  function renderCalc() {
    var w = Number(range.value), mix = mixer(w);
    var cups = mode === 'topper' ? mix.cups : fullCups(w);
    var days = CUPS_PER_BAG / cups;
    $('#wt-num').textContent = w;
    $('#wt-tag').textContent = sizeTag(w);
    $('#c-cups').textContent = frac(cups) + (cups > 1.0625 ? ' cups' : ' cup');
    $('#c-cups-s').textContent = mode === 'topper' ? 'Label range for this size: ' + mix.range + ' cup' : 'From the complete-meal guide';
    $('#c-days').textContent = (days < 5 ? Math.round(days * 2) / 2 : Math.round(days)) + (days < 1.25 ? ' day' : ' days');
    $('#c-cost').textContent = money(catalog.meal.price / days);
    $('#c-note').textContent = mode === 'topper' ? 'Topper amounts follow the label’s mixer guide, which replaces about ¼ of the diet.' : 'Full-meal amounts follow the label’s complete-meal guide.';
  }
  range.addEventListener('input', renderCalc);
  $$('.seg button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      mode = btn.getAttribute('data-mode');
      $$('.seg button').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      renderCalc();
    });
  });
  renderCalc();
  renderCommerce();
  refreshCatalog().catch(function () { status.textContent = "Live availability could not refresh. We will check again when you add a bag."; });

  /* ---------- Label tabs ---------- */
  var LABELS = {
    noms: {
      name: '100% Beef Dog Noms', ing: 'Beef, beef liver, mixed tocopherols (vitamin E).', kcal: '4,949 kcal/kg', orange: false,
      note: 'Supplemental feeding only. Use as a reward, a topper or a mixer. Up to 2 years shelf life sealed; use within 30 days of opening.',
      ga: [['Protein', 'minimum', 36], ['Fat', 'minimum', 35], ['Fiber', 'maximum', 5], ['Moisture', 'maximum', 8]]
    },
    beefy: {
      name: 'Beefy-Tato Complete Meal', kcal: '4,045 kcal/kg · 486 kcal/cup', orange: true,
      ing: 'Beef, beef liver, beef lung, beef kidney, sweet potato, broccoli, tricalcium phosphate, monosodium phosphate, fish oil, blueberry, kale, mixed tocopherols (preservative), apple, tomato, shiitake mushroom, orange, cranberry, pumpkin, spinach, beet, cherry, strawberry, dried seaweed meal, vitamin E supplement.',
      note: 'Beefy-Tato is formulated to meet the nutritional levels established by the AAFCO Dog Food Nutrient Profiles for All Life Stages, including growth of large size dogs (70 lb or more as an adult).',
      ga: [['Protein', 'minimum', 40], ['Fat', 'minimum', 27], ['Fiber', 'maximum', 6], ['Moisture', 'maximum', 8]]
    }
  };
  $$('.tabs button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var L = LABELS[btn.getAttribute('data-tab')];
      $$('.tabs button').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      $('#l-name').textContent = L.name;
      $('#l-ing').textContent = L.ing;
      $('#l-kcal').textContent = L.kcal;
      $('#l-note').textContent = L.note;
      var ga = $('#l-ga');
      ga.classList.toggle('o', L.orange);
      $$('.ga-row', ga).forEach(function (row, i) {
        var g = L.ga[i];
        row.querySelector('span').firstChild.nodeValue = g[0];
        row.querySelector('small').textContent = g[1];
        row.querySelector('.ga-fill').style.width = (g[2] * 2) + '%';
        row.querySelector('.ga-v').textContent = g[2] + '%';
      });
    });
  });

  /* ---------- FAQ accordion (one open at a time) ---------- */
  $$('.qa-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.parentNode, wasOpen = item.classList.contains('open');
      $$('.qa').forEach(function (q) {
        q.classList.remove('open');
        q.querySelector('.qa-btn').setAttribute('aria-expanded', 'false');
        q.querySelector('.ans').hidden = true;
      });
      if (!wasOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
        item.querySelector('.ans').hidden = false;
      }
    });
  });

  /* ---------- Mobile sticky bar ---------- */
  var sticky = $('#sticky'), heroCtas = $('#hero-ctas'), finalSec = $('.final');
  if ('IntersectionObserver' in window) {
    var heroGone = false, finalIn = false;
    var update = function () { sticky.classList.toggle('show', heroGone && !finalIn); };
    new IntersectionObserver(function (e) { heroGone = !e[0].isIntersecting && e[0].boundingClientRect.top < 0; update(); }).observe(heroCtas);
    new IntersectionObserver(function (e) { finalIn = e[0].isIntersecting; update(); }).observe(finalSec);
  } else {
    sticky.classList.add('show');
  }
})();
